export default __webpack_public_path__ + "static/media/17.eec10ef2.jpg";